export default "__VITE_ASSET__bfac1ef2__"